@let isActive = this.basicLayoutHelperService.isNavItemActive(this.navItem)();

@if (this.navItemAccessService.allowedToAccess(this.navItem)()) {
  <span>
    @let hoverBackgroundClasses =
      isActive ? this.BACKGROUND_ACTIVE_CLASS : this.BACKGROUND_DEFAULT_CLASS;
    @let anchorClass =
      'group w-full cursor-pointer rounded-md flex flex-row justify-start items-center gap-2 px-3 py-2 transition-all';

    @if (this.navItem.type === NavItemType.RouterLink) {
      <!-- router link -->
      <a
        [class]="anchorClass"
        [ngClass]="hoverBackgroundClasses"
        [routerLink]="[this.navItem.routerLink]"
        (click)="this.clickNavItem.emit()"
        [attr.data-testid]="'side-menu-item-router-' + this.navItem.id"
      >
        <ng-container *ngTemplateOutlet="navItemContent" />
      </a>
    } @else if (this.navItem.type === NavItemType.OnClick) {
      <!-- on click -->
      <a
        [class]="anchorClass"
        [ngClass]="hoverBackgroundClasses"
        (click)="this.navItem.onClick(); this.clickNavItem.emit()"
        [attr.data-testid]="'side-menu-item-click-' + this.navItem.id"
      >
        <ng-container *ngTemplateOutlet="navItemContent" />
      </a>
    }
  </span>
  <!-- inner content template -->
  <ng-template #navItemContent>
    @let textColorClasses =
      isActive ? this.TEXT_ACTIVE_CLASS : this.TEXT_DEFAULT_CLASS;
    <pm-icon [class]="textColorClasses" [icon]="this.navItem.icon" size="sm" />
    <span
      [ngClass]="textColorClasses"
      class="text-sm flex-1 transition-all line-clamp-1"
    >
      {{ this.navItem.title | translate }}
    </span>
  </ng-template>
}
